export const MonthlyReportState = {
    errorCode : 0,
    statusCode : 0,
    regionList : [],
    message : '',
    lifeGuardAlarm : {
        "RegisteredLifeGuardCount": 0,
        "RecruitedCount": 0,
        "AlarmPerdayCount": 0,
        "ReceivedAlarmCount": 0,
        "AcceptAlarmCount":0,
        "DeclineAlarmCount": 0,
        "LifeGuardOnSceneForCardiacArrestCount": 0,
        "LifeGuardOnSiteBeforeAmbulanceCount":0,
        "LifeGuardPerformedCPRCount":0,
        "LifeGuardConnectedDefibrillatorsCount": 0,
        "LifeGuardUseDefibrillatorsCount": 0,
        "RegionId":null
    },
    UserList:[],
    regionList:[],
    usersList:[],
    alarmList:[]
}